import type { ReviewedDetectionDto } from "../../services/ocr/InspectionReviewService";
import { ocrTsToSeconds } from "./playbackSync";

/**
 * The identity of an OCR-shaped row, in the shape the approved list matches on.
 *
 * All THREE parts, the video position included. stableKeyFor gained it as an optional third
 * part so two damages at the same station stop collapsing into one, and every approved row
 * carries one -- both the seed (ocrMachineRows) and toReviewedDetection set it. A two-part
 * identity built here therefore keyed as `2.43|BAB` against a stored `2.43|BAB|75` and matched
 * nothing: Delete filtered no row at all, and Edit's findIndex missed and appended a duplicate
 * instead of replacing, so both looked like they had done nothing.
 *
 * Read off the row's own timeSeconds, which the page's mirror carries; re-parsing the rendered
 * clock string is only the fallback for a row shaped before that.
 *
 * Its own module rather than a private helper in DetectionList, so the round-trip it has to
 * satisfy can be tested without dragging the component's whole service graph in.
 */
export const identityOf = (d: any): ReviewedDetectionDto =>
  ({
    distance: Number(d?.distance ?? 0),
    mainCode: d?.main_Code ?? "",
    timeSeconds: d?.timeSeconds ?? ocrTsToSeconds(d?.timestamp),
  } as ReviewedDetectionDto);
